import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, InputAdornment, Stack, TableCell, TextField, Typography, Snackbar, MenuItem } from "@mui/material";
import React, { useContext, useEffect, useState, useMemo } from "react";
import { Context } from "../App";
import { API} from "../conf";
import { Close, RemoveCircleOutline, Search, Delete } from "@mui/icons-material";
import xlsx from 'json-as-xlsx';
import SorTableCheckable from "./sortable-checkable";
import SessionForm from "./session-form";
import Header from "./Header";
import pdfMake from 'pdfmake/build/pdfmake';
import vfs from "pdfmake/build/vfs_fonts";

pdfMake.vfs = vfs;

export default function Sessions() {
    const {updateConnect} = useContext(Context)
    const [load, setLoad] = useState(true)
    const [sessions, setSessions] = useState([])
    const [sessionId, setSessionID] = useState('')
    const [delegues, setDelegues] = useState([])
    const [delegue, setDelegue] = useState()
    const [search, setShearch] = useState('')
    const [selectItems, setItems] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [open_snack, setsnack] = useState(false)
    const [snack_msg, setsnack_msg] = useState('')
    const [pdf, setPdf] = useState()

    const session = useMemo(()=>sessions.find(item=>item._id===sessionId), [sessions, sessionId])

    const table = [
        {header: "Catégorie", sortable: true, sortBy:(el)=>el.categorie, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.categorie}</TableCell>},
        {header: "Genre", sortable: true, sortBy:(el)=>el.genre, row: (row, index)=><TableCell key={index}>{row.genre}</TableCell>},
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.nom}</TableCell>},
        {header: "Prénoms", sortable: true, sortBy:(el)=>el.prenoms.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.prenoms}</TableCell>},
        {header: "Mail", sortable: true, sortBy:(el)=>el.mail, row: (row, index)=><TableCell key={index}>{row.mail}</TableCell>},
        {header: "Téléphone", sortable: true, sortBy:(el)=>el.tel??'', row: (row, index)=><TableCell key={index}>{row.tel??''}</TableCell>},
        {header: "Scanner par", sortable: true, sortBy:(el)=>el.agent?(el.agent.nom+' '+el.agent.prenom).toLowerCase():'', row: (row, index)=><TableCell key={index} sx={{textTransform:'capitalize'}}>{row.agent?.nom.toUpperCase()+' '+row.agent?.prenom}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} align="right" sx={{minWidth:'70px'}} >
            <IconButton aria-label="supprimer" onClick={()=>{setDelegue(row); manage_dialog(true, 'delete delegue')}}><RemoveCircleOutline fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.prenoms+' '+item.mail+' '+(item.tel??'')
    }

    function capitalize(text) {
        return text?.split(' ').map(word=> word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
        .split('-').map(word=> word.charAt(0).toUpperCase() + word.slice(1)).join('-');
    }

    function manage_dialog(status, action) {
        setOpen(status); setAction(action)
        if (!status) {
            setDelegue()
        } 
    }

    function handleDelete(ids) {
        setLoad(true)
        fetch(API.concat(`/Session/by/${JSON.stringify({_id:{$in:ids}})}`), {method:'DELETE', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token)
                }
                if (response.status === 204) {
                    setSessions(old=> old.filter(item=>!ids.includes(item._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    function handleDeleteDelegues(selectedDelegues) {
        setLoad(true)
        fetch(API.concat(`/Session/${sessionId}/unregister`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify({delegues: selectedDelegues})
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token)
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setSessions(old=>[...old.filter(item=>item._id!==sessionId), json]);
                    setDelegues(old=> old.filter(dlg=>!selectedDelegues.includes(dlg._id)))
                    manage_dialog(false, '')
                } setLoad(false)
            }
        })
    }

    function handleExport(data) {
        let excel = [
            {
              sheet: session.label,
              columns: [
                { label: "Catégorie", value: (row) => row.categorie }, 
                { label: "Genre", value: (row) => row.genre }, 
                { label: "Nom", value: row => row.nom.toUpperCase() }, 
                { label: "Prénoms", value: row => row.prenoms.split(' ').map(prenom=>prenom.charAt(0).toUpperCase()+prenom.slice(1)).join(' ') }, 
                { label: "Mail", value: row=> row.mail }, 
                { label: "Téléphone", value: row=> row.tel }, 
              ],
              content: data,
            },
        ]
          
        let settings = {
            fileName: `Delegues_present_AGO2025_${Date.now().toLocaleString()}`, // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
        }
          
        xlsx(excel, settings) // Will download the excel file
    }

    useEffect(() =>{
        if(!session) return
        fetch(API.concat(`/sessions/${session._id}/deleguesandagents`), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {delegues, agents} = await response.json()
                    const dlgWithAgent = delegues.map(dlg=>({...dlg, agent: agents.find(agent=>agent._id===session.delegues.find(sdlg=>sdlg.delegue===dlg._id)?.agent)}))
                    setDelegues(dlgWithAgent)
                } setLoad(false)
            }
        })
    }, [session])

    useEffect(()=>{
        fetch(API.concat('/Session/all'), {method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setSessions(json)
                }setLoad(false)
            }
        })
    },[updateConnect]) 

    return(
        <Box display='flex' flex={1} flexDirection='column' marginBottom='30px'>
            <Header/>
            <Typography variant="h4" align="center" marginY={5}>Gestion des sessions de Scan</Typography>
            <Box display='flex' flexWrap='wrap' justifyContent='space-between' alignItems='center' marginX='30px' marginBottom={2}>
                <Stack direction='row' flexWrap='wrap' rowGap={2} columnGap={2} alignItems='center'>
                    <TextField select label='Session' sx={{minWidth:'200px', width:'40%'}} 
                    renderValue={(value)=>sessions.find(item=>item._id===value)?.label??''}
                    value={sessionId} onChange={e=>setSessionID(e.target.value)}>
                        {sessions.length>0 ? sessions.map(item=><MenuItem key={item._id} value={item._id} sx={{display:'flex', justifyContent:'space-between'}}>
                            <span>{item.label+(item.isRepas?'(repas)':'')}</span>
                            <IconButton size="small" color="error" onClick={(e) => {e.stopPropagation(); handleDelete([item._id])}}><Delete /></IconButton>
                        </MenuItem>)
                        : <Typography variant="subtitle1" align="center">Aucune session enregistrée</Typography>
                        }
                    </TextField>
                    <Button variant="contained" onClick={()=>manage_dialog(true, 'add')}>ajouter</Button>
                    <Button variant="contained" disabled={!session} onClick={()=>manage_dialog(true, 'edit')}>modifier</Button>
                </Stack>
                {session&&<Stack direction='row' spacing={2} alignItems='center'>
                    <Typography variant="subtitle1" align="center">Status: {session.active?'active':'inactive'}</Typography>
                </Stack>}
            </Box>
            {session&&<Typography variant="h6" fontWeight='bold' align="center" marginBottom={2}>Délégués scannés à la session {session.label}</Typography>}
            {session&&<Box display='flex' justifyContent='space-between' alignItems='center' marginX='30px'>
                <TextField placeholder="Rechercher un délégué" size="small" sx={{width:'60%', minWidth:'400px'}} value={search} onChange={e=>setShearch(e.target.value)}
                slotProps={{input:{endAdornment: (<InputAdornment position="end"><Search /></InputAdornment>)}}}/>
                <Stack direction='row' spacing={1} alignItems='center'>
                    <Button variant="outlined" disabled={selectItems.length<1} onClick={()=>handleExport(delegues)}>exporter</Button>
                    <Button variant="contained" disabled={selectItems.length<1} onClick={()=>manage_dialog(true, 'delete delegues')}>supprimer</Button>
                </Stack>
            </Box>}

            {session&&<div style={{marginInline:'30px'}}><SorTableCheckable data={delegues.filter(item=> normalize(get_searchable(item)).includes(normalize(search)))} selectItems={selectItems} setItems={setItems} table={table} rowsPerPage={100} rowsPerPageOptions={[50, 100, 300]}/></div>}

            <Snackbar
            open={open_snack}
            autoHideDuration={5000}
            onClose={()=> setsnack(false)}
            message={snack_msg}
            />

            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Dialog open={open} fullWidth maxWidth={['add', 'edit', 'pdf'].includes(action)?'md':'xs'} onClose={()=>manage_dialog(false, '')}>
                <IconButton onClick={()=>manage_dialog(false, '')} sx={{alignSelf:'end', marginTop:'5px', marginRight:'5px'}}><Close/></IconButton>
                {action==='add'&& <SessionForm {...{add:item=>setSessions(old=>[...old, item]), close:()=>manage_dialog(false, '')}} />}
                {action==='edit'&&session&& <SessionForm {...{edit:true, session, add:item=>setSessions(old=>[...old.filter(el=>el._id!==item._id), item]), close:()=>manage_dialog(false, '')}} />}
                {action==='pdf' && pdf &&<Box sx={{marginInline:2}}><embed src={pdf} width='100%' height='600px' type="application/pdf" /></Box>}
                {action==='delete'&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">Supprimer la session {session.label}</Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDelete([session._id])}>supprimer</Button>
                    </Stack>
                </Box>}
                {action.includes('delete delegue')&&<Box display='flex' flexDirection='column' paddingInline={1} paddingBottom={1}>
                    <Typography fontWeight={600} fontSize={18} align="center">
                        Annuler le scan de {action.includes('s')?(selectItems.length+' délégué'+(selectItems.length>1?'s':'')):delegue?.nom.toUpperCase()+' '+capitalize(delegue?.prenoms)}
                    </Typography>
                    <Stack direction='row' spacing={2} marginTop={2} alignItems='center' alignSelf='end'>
                        <Button variant="outlined"  onClick={()=>manage_dialog(false,'')}>annuler</Button>
                        <Button variant="contained" color="carmine" onClick={()=>handleDeleteDelegues(action.includes('s')?selectItems:[delegue._id])}>confirmer</Button>
                    </Stack>
                </Box>}
            </Dialog>
        </Box>
    )
}